const registerForms = document.querySelectorAll('form[data-name="partner-register"]');

const updateAdditionalFields = (additionalFields, value) => {
  additionalFields.forEach((field) => {
    const visibleFor = field.getAttribute('data-visible-for').split(',');
    if (!visibleFor.includes(value)) {
      field.classList.add('is-hidden');
    } else {
      field.classList.remove('is-hidden');
    }
  });
}

const initForm = (form) => {
  const typeSelect = form.querySelector('#business_type');
  const additionalFields = form.querySelectorAll('.field[data-visible-for]');
  updateAdditionalFields(additionalFields, typeSelect.value);

  typeSelect.addEventListener('change', (e) => {
    updateAdditionalFields(additionalFields, e.target.value);
  });

  form.addEventListener('submit', (e) => {
    if (window.dataLayer) {
      window.dataLayer.push({
        'event': 'event',
        'eventCategory': 'Sales Portal',
        'eventAction': 'Registrierung absenden',
        'eventLabel': 'Partner Registrierung',
        'eventNonInteraction': false
      });
    }
  });
};

registerForms.forEach(initForm);


// Owner register
// const ownerRegister = document.querySelector('.registration-form[data-status]');
// if (ownerRegister) {
//   setTimeout(() => {
//     ownerRegister.scrollIntoView();
//   }, 500)
// }
